module.exports = __webpack_public_path__ + "media/images/speak-with-your-vet-fb0c47f6d08fe7944f08fdc1786eeb5e.svg";